import { FileUpload } from "../models/file"

export type Project = {
    id: string
    name: string
    language: string
    logo?: string
    big_logo?: string
}

export interface CreateProjectRequest {
    ProjectName: string
    ProjectId: string
    Language: string
}

export interface CreateProjectFromCopyRequest {
    ProjectName: string
    ProjectId: string
    ArchiveName: string
    Url?: string
}

export interface UpdateProjectRequest {
    Id: string
    Name: string
}

export interface InviteUsersRequest {
    ProjectId: string
    UsersEmails: string[]
    RoleId: string
    IsExternal: boolean
}

export interface BlockUserRequest {
    Login: string
    ProjectId: string
}

export interface IUpdateLogoRequest {
    projectId: string
    logo?: FileUpload<Blob>
    hugeSize?: boolean
}

export enum IntegrationReqType {
    GetUser = "GetUser"
}

export enum IntegrationResType {
    SendUser = "SendUser"
}

type NotificationTypes = keyof typeof IntegrationReqType | keyof typeof IntegrationResType

export type IntegrationIframeMessage = {
    notificationType: NotificationTypes
    message?: Record<string, string>
}
